/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */
import { UserStatus } from '@/context/status-context/status-context.tsx';

export const statusClasses: Record<UserStatus, string> = {
  online: 'bg-green-500',
  dnd: 'bg-red-500',
  away: 'bg-yellow-500',
  invisible: 'bg-gray-500',
  offline: 'bg-gray-500',
  '😀': 'bg-pink-500',
  '☹️': 'bg-pink-500',
  '🎮': 'bg-pink-500',
  '💡': 'bg-pink-500',
};